import { NavLink, useNavigate } from "react-router-dom";
import classes from "./SideMenu.module.css";
import clsx from "clsx";
import { UserContext } from "../../contexts/AuthContext";
import { useContext } from "react";

const SideMenu = () => {
  const { logout, toggleMenuFlag, handleMenu } = useContext(UserContext);
  const navigate = useNavigate();

  const handleAllSongsClick = () => {
    handleMenu();
    navigate("/dashboard/all-songs", { replace: true });
  };

  const handleLogout = ()=> {
    handleMenu();
    logout()
  }
  return (
    <>
    <nav className={clsx(classes.sideNav, toggleMenuFlag && classes.showNav)}>
        <ul>
          <li>
            <a onClick={handleAllSongsClick} className={classes.navLink}>All Songs</a>
          </li>
          <li>
            <NavLink to={"/dashboard/add-new-song"} onClick={handleMenu}>Add a song</NavLink>
          </li>
          <li>
              <span className={classes.logoutButton} onClick={handleLogout}>
                  Logout
              </span>
          </li>
        </ul>
      </nav>
    </> 
  );
};
export default SideMenu;
